/* eslint-disable vue/no-unused-properties -- свойства mixin'а используются в компонентах-потребителях (*RangeField.vue) */
import { defineComponent, PropType } from 'vue';

export const DEFAULT_RANGE_PLACEHOLDERS: [string, string] = ['от', 'до'];

/**
 * Общая модель для полей-диапазонов «от/до» (дата, число, время).
 * Даёт writable-computed `fromModel`/`toModel` поверх пропсов `from`/`to`
 * с эмитом `update:from`/`update:to` (для `v-model:from` / `v-model:to`),
 * а также общие пропсы `labels`, `required`, `disabled`.
 */
type TRangeValue = string | number | null;
type TRangeFieldModel = string | number | undefined;

export default defineComponent({
  props: {
    from: {
      type: [String, Number] as PropType<TRangeValue>,
      default: null,
    },
    to: {
      type: [String, Number] as PropType<TRangeValue>,
      default: null,
    },
    // Подписи «От»/«До» слева от полей. Если не заданы — используются плейсхолдеры внутри полей.
    labels: {
      type: Array as PropType<string[]>,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    'update:from': (value: TRangeValue) => value === null || ['string', 'number'].includes(typeof value),
    'update:to': (value: TRangeValue) => value === null || ['string', 'number'].includes(typeof value),
  },
  computed: {
    fromModel: {
      get(): TRangeFieldModel {
        return this.from ?? undefined;
      },
      set(value: TRangeFieldModel) {
        this.$emit('update:from', value ?? null);
      },
    },
    toModel: {
      get(): TRangeFieldModel {
        return this.to ?? undefined;
      },
      set(value: TRangeFieldModel) {
        this.$emit('update:to', value ?? null);
      },
    },
    hasLabels(): boolean {
      return Array.isArray(this.labels) && this.labels.length === 2;
    },
  },
});
